export default __webpack_public_path__ + "static/media/marker.b32e0001.svg";